import { Download, Eye } from 'lucide-react';

export default function Calendar() {
  const downloadLink =
    'https://drive.google.com/uc?export=download&id=1KdDJXOeaMaLiN_FLh7InvCp4Za4Qo0lu';

  // Google Drive embed preview link
  const previewEmbed =
    'https://drive.google.com/file/d/1KdDJXOeaMaLiN_FLh7InvCp4Za4Qo0lu/preview';

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div
        className="relative py-20 text-white overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #001f3f 0%, #003d66 100%)' }}
      >
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 right-20 w-64 h-64 rounded-full border-2 border-dawoodi-gold/30"></div>
          <div className="absolute bottom-10 left-20 w-48 h-48 rounded-full border-2 border-dawoodi-gold/30"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

          <h1 className="font-playfair text-6xl md:text-7xl font-bold mb-4">Calendar</h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20">

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-16">

          {/* Open Full Preview */}
          <a
            href={previewEmbed}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-gradient-to-br from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white px-10 py-4 rounded-2xl shadow-lg font-poppins flex items-center gap-3 transition-all hover:-translate-y-1"
          >
            <Eye className="w-6 h-6" />
            <span className="font-semibold">Open Fullscreen Preview</span>
          </a>

          {/* Download */}
          <a
            href={downloadLink}
            className="group bg-gradient-to-br from-emerald-500 to-emerald-700 hover:from-emerald-600 hover:to-emerald-800 text-white px-10 py-4 rounded-2xl shadow-lg font-poppins flex items-center gap-3 transition-all hover:-translate-y-1"
          >
            <Download className="w-6 h-6" />
            <span className="font-semibold">Download PDF</span>
          </a>
        </div>

        {/* Embedded Preview */}
        <div className="mb-20">
          <h2 className="font-playfair text-4xl font-bold text-dawoodi-navy mb-6">
            Calendar
          </h2>

          <div className="rounded-3xl overflow-hidden shadow-2xl border border-dawoodi-gold/20">
            <iframe
              src={previewEmbed}
              className="w-full h-[900px] md:h-[1100px]"
              allow="fullscreen"
              title="Calendar Preview"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
